/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Value_LabelInputs */



/**
* | output |
* | --- |
* | "Metadata Value" |
*
* @param {Options_Metadata_Value_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_value_label = /** @type {((inputs?: Options_Metadata_Value_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Value_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Valeur de métadonnée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadatenwert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valore dei metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Значение метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Valor de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータ値")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा मान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Valor dos metadados")
	return /** @type {LocalizedString} */ ("Metadata Value")
});